import { ExpectedTaskAnswerMetadata, Task } from "@jelly/lesson";

const items = [
  { id: "d5ef78d0-3a4e-4916-9c16-d2e69a7d9990", content: "The reverberation time will increase.", options: {} },
  {
    id: "fefd78d7-b054-4bef-9d7a-48c113f80114",
    content: "The perceived loudness of the source will decrease.",
    options: {},
  },
  { id: "7d9b1d65-c761-43d0-8077-ee04a4b43b9f", content: "The perceived clarity will be improved.", options: {} },
  { id: "9d0f6c50-b2ab-4c14-87b0-f4a10b767c44", content: "The feeling of intimacy will be stronger.", options: {} },
  {
    id: "bcbcf1e3-e54e-4ee0-9ca3-99f4d89a6298",
    content: "The perceived width of the source will increase.",
    options: {},
  },
];

export const task: Task = {
  id: "9d411ef2-8515-4584-8862-56f66256963a",
  solutionType: "select",
  type: "checkbox",
  options: {
    isMultiple: true,
    shuffle: true,
  },
  items,
};

export const expectedAnswerMetadata: ExpectedTaskAnswerMetadata = {
  solutionType: "select",
  data: ["7d9b1d65-c761-43d0-8077-ee04a4b43b9f", "bcbcf1e3-e54e-4ee0-9ca3-99f4d89a6298"],
};
